/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Service } from '@/types/ServicePackage'
import Answer from './Answer'

export default class Question {
  private json: any
  public readonly uid: string
  public readonly heading: string;
  public readonly description: string;
  public readonly isMultipleChoice: boolean;
  public readonly answers: Answer[] = [];
  public readonly isEditSelectionsQuestion: boolean;
  public readonly label?: string;
  public readonly title: string;

  constructor (data: any) {
    this.json = data
    this.title = (data.title as string).substring(0, (data.title as string).indexOf('-')).trim()
    this.uid = this.json.uid
    this.heading = this.json.heading
    this.description = this.json.description
    this.isMultipleChoice = this.json.type !== 'Single Answer'
    this.answers = this.json.answers.map((a: any) => Answer.of(a, data.next_question[0]?.uid))
    this.isEditSelectionsQuestion = this.json.edit_selections_question
    this.label = this.json.question_label
  }

  public get services (): Service[] {
    const packages: Service[] = []

    this.answers.forEach(({ retailPrice, procedureCode, hasTiers, tiers }) => {
      if (procedureCode && retailPrice !== undefined) {
        packages.push({ procedureCode: procedureCode, charges: retailPrice })
      }

      if (hasTiers) {
        tiers.forEach(({ procedureCode, retailPrice }) => packages.push({ procedureCode, charges: retailPrice }))
      }
    })
    return packages
  }

  static of (data: any): Question {
    return new Question(data)
  }
}
